import { EmberRoute } from '../../../../../enums/emberRoute'
import { reactRoute } from '../../../../../utils/routing/reactRoute'
import { ExternalInvoiceBalanceModifierReference } from '../elements/InvoiceViewActions/enums/ExternalInvoiceBalanceModifierReference'

const externalInvoicePaymentPaneItemRouteMap = (
  modifierId: string,
  modifierType: ExternalInvoiceBalanceModifierReference,
): Record<ExternalInvoiceBalanceModifierReference, string> => ({
  [ExternalInvoiceBalanceModifierReference.BankPayment]: EmberRoute.BankPayment,
  [ExternalInvoiceBalanceModifierReference.Invoice]: EmberRoute.Invoice,
  [ExternalInvoiceBalanceModifierReference.ExternalInvoice]: reactRoute.organization.invoices.getViewInvoiceRoute(
    modifierId,
    /** As External invoices are considered `invoice` at routing */
    ExternalInvoiceBalanceModifierReference.Invoice,
  ),
  [ExternalInvoiceBalanceModifierReference.InvoiceLateFee]: EmberRoute.InvoiceLateFee,
  [ExternalInvoiceBalanceModifierReference.CreditNote]: reactRoute.organization.invoices.getViewInvoiceRoute(
    modifierId,
    modifierType,
  ),
  [ExternalInvoiceBalanceModifierReference.ContactBalancePayment]: EmberRoute.ContactBalancePayment,
  [ExternalInvoiceBalanceModifierReference.DaybookTransaction]: EmberRoute.DaybookTransaction,
})

export const getExternalInvoicePaymentPaneItemRoute = (
  modifierId: string,
  modifierType: ExternalInvoiceBalanceModifierReference,
): string => {
  return externalInvoicePaymentPaneItemRouteMap(modifierId, modifierType)[modifierType]
}
